import { Component, Input, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

// services
import { PolicyComponentService } from '@open-portal-app/core/services/policy-component.service';

import { BADGE_STATUS } from '@open-portal-app/core/constants/policy.constants';

export interface IDataInterface {
  productClass?: string,
  policyTypeLabel?: string,
  policyNumber?: string
}

@Component({
  selector: 'app-policy-hero-banner',
  templateUrl: './policy-hero-banner.component.html',
  styleUrls: ['./policy-hero-banner.component.scss']
})
export class PolicyHeroBannerComponent implements OnInit {
  @Input() data!: any;
  dynamicMarkup = '';
  badgeVariant = '';
  badgeStatus = BADGE_STATUS as any;

  constructor(
    private router: Router,
    private elementRef: ElementRef,
    private policyComponentService: PolicyComponentService
  ) {}

  ngOnInit(): void {
    if (this.data) {
      const element = this.elementRef.nativeElement;
      element.style.setProperty('--desktop-banner', this.data.desktopBannerImage !== null ? `url(${this.data.desktopBannerImage})` : '');
      element.style.setProperty('--mobile-banner', this.data.mobileBannerImage !== null ? `url(${this.data.mobileBannerImage})` : '');
      
      this.dynamicMarkup = this.policyComponentService.getSnapshot(this.data);
    }
  }

  navigateBack() {
    this.router.navigate(['/dashboard']);
  }

  copyPolicyNumber(policyNumber: string): void {
    navigator.clipboard.writeText(policyNumber);
  }
}
